import { FilterActions, FilterState } from './types';
import { createContext, Dispatch } from 'react';

export const VariantsFilterContext = createContext<[FilterState, Dispatch<FilterActions>] | undefined>(undefined);
